import { Component, ComponentInterface, Prop, JSX } from '@stencil/core';
import { CountriesEnum } from '../../generated/operations';
import { store } from '../../utils/store';

@Component({
  tag: 'render-country',
  shadow: false,
})
export class RenderCountry implements ComponentInterface {
  @Prop() countryCode!: CountriesEnum;

  public render(): JSX.Element {
    const config = store.state.config;
    if (config === null || !config.countries) {
      return this.countryCode;
    }
    const current = config.countries.find((item) => item.code === this.countryCode);
    if (current) {
      return current.data.countryName;
    }
    return this.countryCode;
  }
}
